import service from "@/utils/request";
//获取个人信息
export let userinfoApi = (data) => {
  return service.post(`my/userinfor`, data);
}
// 修改个人信息
export let updateuserinfoApi = (data) => {
  return service.post(`my/edituserinfor`, data);
}
// 获取地址列表
export let addresslistApi = (data) => {
  return service.post(`adress/adresslist`, data);
}
// 添加修改地址有id编辑没id添加
export let addeditaddressApi = (data) => {
  return service.post(`adress/addadress`, data);
}
// 获取地址详情
export let addressinfoApi = (data) => {
  return service.post(`adress/adressdetail`, data);
}
// 删除地址
export let addressdelApi = (data) => {
  return service.post(`adress/deladress`, data);
}
// 设置默认地址
export let addresssetdefaultApi = (data) => {
  return service.post(`adress/setmoren`, data);
}

// 企业认证
export let qiyerenzhengApi = (data) => {
  return service.post(`my/companyrenzheng`, data);
}
// 获取凭证类型
export let getvouchertypeApi = (data) => {
  return service.post(`common/companytype`, data);
}

// 用户订单列表
export let userorderlistApi = (data) => {
  return service.post(`my/myorderlist`, data);
}
// 订单详情
export let userorderinfoApi = (data) => {
  return service.post(`my/myorderdetail`, data);
}
// 申请售后
export let applyafterApi = (data) => {
  return service.post(`my/applyorder`, data);
}
// 售后订单列表
export let afterorderlistApi = (data) => {
  return service.post(`my/mybackorderlist`, data);
}
// 取消售后
export let cancelafterApi = (data) => {
  return service.post(`my/cancelorder`, data);
}
// 取消订单
export let cancelorderApi = (data) => {
  return service.post(`my/quxiaorder`, data);
}

// 余额记录
export let usermoneylogApi = (data) => {
  return service.post(`my/usermoneylog`, data);
}